export default {
  owned: '拥有',

  gem_prestigeStone: {
    name: '声望石',
    description: '获得与您的最佳周期相等的声望货币'
  },
  mining_goldenHammer: {
    name: '金锤',
    description: '为这门手艺找到最好的镐'
  },
  village_ingredientBox: {
    name: '配料箱',
    description: '含有只有在这些盒子里才能找到的特殊成分'
  },
  horde_manaPotion: {
    name: '法力药水',
    description: '补充50%的最大法力值'
  },
  farm_basic: {
    name: '基础肥料',
    description: ''
  },
  farm_flower: {
    name: '花肥',
    description: ''
  },
  farm_speedGrow: {
    name: '快速生长',
    description: ''
  },
  farm_richSoil: {
    name: '肥沃的土壤',
    description: ''
  },
  farm_shiny: {
    name: '闪亮肥料',
    description: ''
  },
  farm_juicy: {
    name: '多汁肥料',
    description: ''
  },
  farm_dissolving: {
    name: '作物溶解剂',
    description: ''
  },
  farm_potatoWater: {
    name: '土豆水',
    description: ''
  },
  farm_roseWater: {
    name: '玫瑰水',
    description: ''
  },
  farm_weedKiller: {
    name: '除草剂',
    description: ''
  },
  farm_turboGrow: {
    name: '涡轮生长',
    description: ''
  },
  farm_premium: {
    name: '优质肥料',
    description: ''
  },
  farm_analyzing: {
    name: '分析肥料',
    description: ''
  },
  farm_superJuicy: {
    name: '超级多汁',
    description: ''
  },
  farm_pellets: {
    name: '颗粒',
    description: ''
  },
  farm_supplementsS: {
    name: '补充 (S)',
    description: ''
  },
  farm_supplementsM: {
    name: '补充 (M)',
    description: ''
  },
  farm_supplementsL: {
    name: '补充 (L)',
    description: ''
  },
  farm_supplementsXL: {
    name: '补充 (XL)',
    description: ''
  },
  farm_supplementsXXL: {
    name: '补充 (XXL)',
    description: ''
  },
  gallery_surpriseParty: {
    name: '惊喜派对',
    description: '获得 500 动机'
  },
  treasure_upArrow: {
    name: '上箭头',
    description: '提高宝藏等级 2'
  },
  treasure_expander: {
    name: '扩展器',
    description: '宝藏等级随时间增加，但不能使用碎片升级'
  },
  treasure_wildcard: {
    name: '通配符',
    description: '所有的效果都可以重新选择'
  },
  treasure_eventStar: {
    name: '活动星级',
    description: '添加事件力量作为效果'
  },
};
